import { render, staticRenderFns } from "./FondsAide.vue?vue&type=template&id=64a1d25c&scoped=true&"
import script from "./FondsAide.vue?vue&type=script&lang=js&"
export * from "./FondsAide.vue?vue&type=script&lang=js&"
import style0 from "./FondsAide.vue?vue&type=style&index=0&id=64a1d25c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1d25c",
  null
  
)

export default component.exports